/* PKW GUTACHTER – Nachtraege zum Entwurf
   ==========================================================================
   Fuenf Dinge, die maximal.js in einem Laden nicht leistet. Alle fuenf sind
   klein und stehen deshalb in einer Datei statt in fuenfen.

   1. APPLAUS ZUM KONFETTI
      maximal.js bringt das Konfetti mit, den Ton aber nicht: es sucht dafuer
      ein Element #applaus-daten, in dem im Entwurf die Tondatei als Rohdaten
      in der Seite stand - achtzig Kilobyte Base64 auf jeder Seite. In einem
      Laden hat das nichts zu suchen. Die Datei liegt stattdessen bei Shopify
      und wird von hier geladen.

      Vorgeladen wird nach dem Seitenaufbau, nicht beim Klick: wer erst beim
      Klick laedt, hoert den Applaus eine halbe bis zwei Sekunden spaeter -
      das Konfetti ist dann schon halb unten und der Ton wirkt wie ein
      Versehen. Geladen wird nur dort, wo es etwas zu feiern gibt; ohne
      [data-konfetti] auf der Seite passiert gar nichts.

   2. DIE KLASSE "an" VON DER SEITE NEHMEN
      "an" heisst im Entwurf zweierlei: die Anlasskachel auf der
      Unternehmensseite - und der Zustand "diese Seite wird gerade gezeigt".
      maximal.js setzt den Zustand auf <div class="seite">.

      Fuers Aussehen faengt max-shop.css das ab. Eine Sache kann CSS aber
      nicht: maximal.js prueft beim Zeigen des eigenen Mauszeigers mit
      closest(".an"), ob unter dem Zeiger etwas Anklickbares liegt. Da die
      ganze Seite in einem Element mit dieser Klasse steckt, ist die Antwort
      immer ja - der Zeigerring bliebe dauerhaft gross und verloere damit
      genau die Rueckmeldung, fuer die es ihn gibt.

      Deshalb wird die Klasse abgenommen, nachdem maximal.js sie gesetzt und
      gelesen hat. Das geht auf, weil alle Skripte mit defer geladen werden
      und in der Reihenfolge des Dokuments laufen: maximal.js ist fertig,
      bevor diese Datei anfaengt. Bei einem Sprung im Adressfeld setzt
      maximal.js sie erneut, darum die zweite Runde nach dem Wechsel.

   3. NOTAUSGANG FUER DEN VORHANG
      Beim ersten Aufruf legt sich #vorhang als volle blaue Flaeche ueber die
      Seite; maximal.js zieht ihn hoch und entfernt ihn. Solange er liegt,
      ist die Seite zwar vollstaendig da, aber nicht zu sehen.

      Genau das ist einmal passiert: ein Fehler in der allerersten Zeile von
      maximal.js liess das ganze Skript stehen - und damit blieb der Vorhang
      liegen. Von aussen sah es aus, als sei die Seite kaputt; tatsaechlich
      war sie nur zugedeckt.

      Diese Datei ist eine eigene Skriptdatei. Ein Fehler in maximal.js hindert
      sie nicht am Laufen. Sie raeumt den Vorhang weg, falls er nach fuenf
      Sekunden noch da ist. maximal.js hat eine eigene Notbremse bei 4,2
      Sekunden - danach steht der Vorhang nur noch, wenn das Skript gar nicht
      mehr laeuft.

      Wer ueberhaupt kein JavaScript hat, sieht ihn nie: die Klasse no-js am
      html-Element blendet ihn per CSS aus, und entfernt wird sie ganz oben
      im Layout vom ersten Skript, das ueberhaupt laeuft.

   4. VERWEIS, DER ALLEIN IM ABSATZ STEHT
      Im Fliesstext soll ein Verweis, der allein in seinem Absatz steht, wie
      eine Schaltflaeche aussehen - mitten im Satz aber wie ein Wort.
      Unterschieden wurde das in CSS mit :only-child, und das ist falsch:
      :only-child zaehlt nur Elemente, keine Textknoten. In

        <p>Termin ueber unser <a>Kontaktformular</a>. Wir freuen uns ...</p>

      ist das <a> das einzige ELEMENT und wurde damit mitten im Satz zum
      Knopf - der Satz brach um ihn herum auseinander. Das laesst sich in
      CSS nicht loesen, deshalb steht die Pruefung hier: nur wenn der Text
      des Absatzes wirklich nur aus dem Verweis besteht, bekommt er die
      Klasse, an der max-plus.css die Schaltflaeche haengt.

   5. ZEITSTRAHL AUS DER FIRMENGESCHICHTE
      Auf "Ueber uns" steht die Geschichte des Hauses als vierzehn Bloecke
      aus Datum, Ueberschrift und Absatz. Fachlich ist das richtig
      ausgezeichnet, optisch ist es eine Wand aus gleich aussehenden
      Absaetzen - die Jahreszahlen gehen darin unter, obwohl sie der Punkt
      der ganzen Strecke sind.

      Hier werden diese Bloecke erkannt und zu einem Zeitstrahl umgebaut.
      Erkannt wird ein Datumsabsatz an drei Dingen zusammen: er enthaelt nur
      eine Fettung und sonst kein Element, sein ganzer Text besteht aus
      dieser Fettung, und darin steht nichts als ein deutscher Monatsname
      mit Jahreszahl. Danach muss direkt eine h3 folgen. Das ist eng genug,
      dass kein anderer Absatz der Seite hineinrutscht - "<strong>Mai
      2023</strong> war ein gutes Jahr" faellt heraus, weil der Text mehr
      ist als die Fettung.

      Umgebaut wird im Browser und nicht im Text: der Text gehoert dem
      Kunden. Wer im Editor eine Station ergaenzt - Monat und Jahr fett,
      darunter eine h3 -, bekommt sie ohne weiteres Zutun mit im Strahl.
      Wer die Form nicht trifft, sieht seinen Absatz unveraendert; kaputt
      geht dabei nichts.

   NICHT MEHR HIER: DER ZWEITE BESTELLKNOPF
      Dass die mitlaufende Leiste auf der Produktseite frueher erscheint,
      stand kurz in dieser Datei und steht jetzt in motion.js, wo sie
      hingehoert. Der Versuch, sie von hier aus zu uebernehmen, ging auf
      einer falschen Annahme aus: Skripte mit defer laufen zwar in der
      Reihenfolge des Dokuments, aber wenn sie laufen, ist das Dokument
      bereits geparst - readyState steht auf "interactive" und nicht mehr
      auf "loading". motion.js wartet deshalb gar nicht auf
      DOMContentLoaded, sondern legt sofort los und hat seine Marke
      gesetzt, lange bevor diese Datei ueberhaupt aufgerufen wird.
   ========================================================================== */
(function () {
  "use strict";

  /* ---- 1. Applaus ------------------------------------------------------ */
  (function () {
    var cfg = window.PKW_TON || {};
    if (!cfg.an || !cfg.url) { return; }

    var mq = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mq && mq.matches) { return; }

    var ton = null;

    function laden() {
      if (ton || !document.querySelector("[data-konfetti]")) { return; }
      try {
        ton = new Audio(cfg.url);
        ton.preload = "auto";
        ton.volume = Math.min(1, Math.max(0, (cfg.vol || 70) / 100));
        ton.load();
      } catch (e) { ton = null; }
    }

    function spielen() {
      if (!ton) { laden(); }
      if (!ton) { return; }
      try {
        ton.currentTime = 0;
        /* Browser lehnen das Abspielen ohne Nutzergeste ab. Hier gibt es
           immer eine - den Klick -, abgefangen wird es trotzdem: eine
           unbeantwortete Zusage wirft sonst in der Konsole. */
        var p = ton.play();
        if (p && p.catch) { p.catch(function () {}); }
      } catch (e) {}
    }

    /* Ein Zuhoerer am Dokument statt einer je Knopf: der Knopf in der
       Fussleiste loest den Jubelknopf im Startbild per Klick aus, und
       Bloecke koennen im Theme-Editor nachtraeglich dazukommen. */
    document.addEventListener("click", function (e) {
      var z = e.target.closest && e.target.closest("[data-konfetti]");
      if (z) { spielen(); }
    });

    if (document.readyState === "complete") { laden(); }
    else { window.addEventListener("load", laden); }
  })();

  /* ---- 2. Klasse "an" von der Seite nehmen ----------------------------- */
  (function () {
    function abnehmen() {
      Array.prototype.forEach.call(document.querySelectorAll(".seite.an"), function (s) {
        s.classList.remove("an");
      });
    }
    abnehmen();
    /* maximal.js setzt sie beim Sprung im Adressfeld erneut. Der kurze
       Aufschub laesst dessen Zuhoerer zuerst laufen. */
    window.addEventListener("hashchange", function () { setTimeout(abnehmen, 60); });
  })();

  /* ---- 3. Notausgang fuer den Vorhang ---------------------------------- */
  (function () {
    function raeumen() {
      var v = document.getElementById("vorhang");
      if (!v) { return; }
      document.body.style.overflow = "";
      v.parentNode.removeChild(v);
      try { window.dispatchEvent(new Event("vorhang:weg")); } catch (e) {}
    }
    /* Fuenf Sekunden: maximal.js raeumt spaetestens nach 4,2 selbst auf.
       Steht der Vorhang danach noch, laeuft dort nichts mehr. */
    setTimeout(raeumen, 5000);
  })();

  /* ---- 4. Verweis, der allein im Absatz steht -------------------------- */
  (function () {
    function markieren() {
      Array.prototype.forEach.call(document.querySelectorAll(".rte p"), function (p) {
        if (p.children.length !== 1) { return; }
        var a = p.firstElementChild;
        if (!a || a.tagName !== "A") { return; }
        if (p.textContent.trim() === a.textContent.trim()) { p.classList.add("nur-link"); }
      });
    }
    markieren();
    /* Im Theme-Editor werden Abschnitte einzeln nachgeladen. */
    document.addEventListener("shopify:section:load", markieren);
  })();

  /* ---- 5. Zeitstrahl aus der Firmengeschichte -------------------------- */
  (function () {
    var MONAT = /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember)\s+(19|20)\d{2}$/;

    function istDatum(el) {
      if (!el || el.tagName !== "P" || el.children.length !== 1) { return false; }
      var s = el.firstElementChild;
      if (!s || (s.tagName !== "STRONG" && s.tagName !== "B")) { return false; }
      var t = el.textContent.trim();
      return t === s.textContent.trim() && MONAT.test(t);
    }

    function bauen(rte) {
      if (rte.getAttribute("data-zeit")) { return; }
      rte.setAttribute("data-zeit", "1");

      var kind = rte.firstElementChild;

      while (kind) {
        if (!istDatum(kind)) { kind = kind.nextElementSibling; continue; }

        var strahl = document.createElement("div");
        strahl.className = "zeit";
        rte.insertBefore(strahl, kind);

        while (istDatum(kind)) {
          var datum = kind;
          var titel = datum.nextElementSibling;

          /* Datum ohne Ueberschrift dahinter: Finger weg, der Absatz bleibt
             wie er ist. Weitergezaehlt wird trotzdem - ohne diese Zeile
             stuende die Schleife hier fuer immer. */
          if (!titel || titel.tagName !== "H3") { kind = datum.nextElementSibling; break; }

          kind = titel.nextElementSibling;

          var e = document.createElement("div");
          e.className = "zeit-e";
          var d = document.createElement("span");
          d.className = "zeit-d";
          d.textContent = datum.textContent.trim();
          e.appendChild(d);

          datum.parentNode.removeChild(datum);
          e.appendChild(titel);

          /* Alles, was danach an Absaetzen kommt, gehoert zu dieser Station -
             bis zum naechsten Datum oder bis etwas anderes als ein Absatz
             auftaucht. Die naechste h2 beendet damit die Strecke. */
          while (kind && kind.tagName === "P" && !istDatum(kind)) {
            var w = kind;
            kind = kind.nextElementSibling;
            e.appendChild(w);
          }

          strahl.appendChild(e);
        }

        if (!strahl.children.length) { strahl.parentNode.removeChild(strahl); }
      }
    }

    function alle() {
      Array.prototype.forEach.call(document.querySelectorAll(".rte"), bauen);
    }

    alle();
    document.addEventListener("shopify:section:load", alle);
  })();
})();
